import dashboardHorizontalIcon from '@disy/cadenza-icons/dashboard-hor-split.svg';

import { Action } from 'cadenza/action';
import { icon } from 'cadenza/utils/icon/icon';
import { VIEW } from 'cadenza/map-dashboard/event-types';
import type { TableView } from 'cadenza/map-dashboard/table-view/table-view';

import i18n from '../messages.properties';

export class ToggleHorizontalLayoutAction extends Action {

  _tableView: TableView;

  constructor (tableView: TableView) {
    super({ label: i18n('horizontalLayout'), icon: icon(dashboardHorizontalIcon) });
    this._tableView = tableView;
  }

  override executeSync () {
    this._tableView.dispatchEvent(new CustomEvent(VIEW.LAYOUT_CHANGED, { bubbles: true, detail: { orientation: 'horizontal' } }));
  }

  override isSupportedSync () {
    return true;
  }

}
